import React from 'react';
import { storeLog } from '@/api/lookup';
import ErrorView from '@/sections/error/error-view';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Aggiorna lo stato in modo che il prossimo rendering mostri l'UI di fallback.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log dell'errore al backend tramite storeLog solo se abilitato
    if (this.props.enabled) {
      storeLog(`React Error: "${error?.message.length > 30 ? error?.message.substring(0,30) + '...' : error?.message}"`, 'warning', {
        message: error?.message,
        stack: error?.stack,
        componentStack: JSON.stringify(errorInfo?.componentStack),
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return <ErrorView />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
